<template>
    <div>
        <div class="section">
            <div class="columns">
              <aside class="column is-2">
                <nav class="menu">
                <img id="logo" src="public/assets/logo.jpg" alt="Digital Institute" />

                  <p class="menu-label">
                    HOME
                  </p>
                  <ul class="menu-list">
                    <li><a @click="onHomeClick()">Home</a></li>
                  </ul>

                  <p class="menu-label">
                    CHARTS
                  </p>
                  <ul class="menu-list">

                    <li>
                      <a><em>Bubble Charts</em></a>
                      <ul>
                        <li><a @click="onChartClick('pragmaticsBubbleVisible')">Pragmatics</a></li>
                        <li><a @click="onChartClick('methodBubbleVisible')">Method</a></li>
                        <li><a @click="onChartClick('aestheticsBubbleVisible')">Aesthetics</a></li>
                        <li><a @click="onChartClick('blendedBubbleVisible')">Blended</a></li>
                      </ul>
                    </li>
                    <li>
                      <a><em>Bar Charts</em></a>
                      <ul>
                        <li><a @click="onChartClick('barChartVisible')">Bar Chart</a></li>
                        <li><a @click="onChartClick('barMultiplesVisible')">Bar Multiples</a></li>
                      </ul>
                    </li>

                    <li>
                      <a><em>Pie Charts</em></a>
                      <ul>
                        <li><a @click="onChartClick('pieChartVisible')">Pie Chart</a></li>
                       <!-- <li><a @click="onChartClick('barMultiplesVisible')">Bar Multiples</a></li> -->
                      </ul>
                    </li>
                    <a><em>Line Charts</em></a>
                    <li><a @click="onChartClick('lineChartVisible')">Line Chart</a></li>
                    <li><a @click="onChartClick('lineMultiplesVisible')">Line Multiples</a></li>
                  </ul>

                  <p class="menu-label">
                    TIMELINES
                  </p>
                  <ul class="menu-list">
                    <li><a @click="onTimelineClick">Timeline Chart</a></li>
                  </ul>

                  <p class="menu-label">
                    EXPERIMENTAL CHARTS
                  </p>

                  <ul class="menu-list">
                    <li><a href="public/scatter.html">Scatter Plot</a></li>
                    <li><a href="public/wordtree.html">WordTree/Dendrogram</a></li>
                    <li><a href="public/nodes.html">Link node</a></li>
                  </ul>
                </nav>
              </aside>

                <main class="column">

                     <AppHeader></AppHeader>

                      <div class="level">

                        <div v-show="showAppText">
                          <AppText></AppText>
                        </div>
                      </div>

                    <div class="level">

                          <div v-show="charts.lineChartVisible">
                            <LineChart :mydata="itemsByYear"></LineChart>
                          </div>

                          <div v-show="charts.lineMultiplesVisible">
                            <LineMultiples :mydata="itemsByYear"></LineMultiples>
                          </div>

                         <div v-show="charts.aestheticsBubbleVisible">
                             <BubbleChartAesthetics :mydata="itemsByYear"></BubbleChartAesthetics>
                         </div>

                          <div v-show="charts.pragmaticsBubbleVisible">
                              <BubbleChartPragmatics :mydata="itemsByYear"></BubbleChartPragmatics>
                          </div>

                          <div v-show="charts.methodBubbleVisible">
                              <BubbleChartMethod :mydata="itemsByYear"></BubbleChartMethod>
                          </div>

                          <div v-show="charts.blendedBubbleVisible">
                              <BubbleChartBlended :mydata="itemsByYear"></BubbleChartBlended>
                          </div>

                          <div v-show="charts.barChartVisible">
                            <BarChart  :mydata="itemsByYear"></BarChart>
                          </div>

                          <div v-show="charts.barMultiplesVisible">
                            <BarMultiples :mydata="itemsByYear"></BarMultiples>
                          </div>

                          <div v-show="charts.pieChartVisible">
                            <PieChart :mydata="itemsByYear"></PieChart>
                          </div>

                          <div v-show="charts.timelineChartVisible">
                            <TimelineChart></TimelineChart>
                          </div>
                      </div>

                      <div class="level">

                        <!-- hide modal button for the moment -->

                      <!--<div class="level-item">
                            <button  v-show="showModalButton"  @click="showAppModal = true"><a href="#">Show key as modal</a></button>
                            <AppModal v-if="showAppModal" :appModalData='customData'  @close="showAppModal = false"  />
                          </div> -->
                      </div>

                  <AppFooter></AppFooter>


                </main>
            </div>
        </div>
    </div>
</template>

<script>

    import ScatterChart from "./ScatterChart";
    import LineChart from "./LineChart";
    import LineMultiples from "./LineMultiples";
    import BubbleChartPragmatics from "./BubbleChartPragmatics";
    import BubbleChartBlended from "./BubbleChartBlended";
    import BubbleChartMethod from "./BubbleChartMethod";
    import BubbleChartAesthetics from "./BubbleChartAesthetics";
    import BarChart from "./BarChart";
    import BarMultiples from "./BarMultiples";
    import PieChart from "./PieChart";
    import TimelineChart from "./TimelineChart";
    import AppKey from "./AppKey";
    import AppText from "./AppText";
    import AppFooter from "./AppFooter";
    import Variables from "./Variables"
    import AppModal from "./AppModal";
    import AppHeader from "./AppHeader";

    import data from '../json/data.json';
    import dataByYear from '../json/databyyear.json';


    export default {
        name: "HomeComponent",
        components: {
            BubbleChartPragmatics,
            BubbleChartBlended,
            BubbleChartMethod,
            BubbleChartAesthetics,
            BarChart,
            LineChart,
            LineMultiples,
            BarMultiples,
            PieChart,
            ScatterChart,
            TimelineChart,
            AppKey,
            Variables,
            AppModal,
            AppText,
            AppHeader,
            AppFooter
        },
        data() {
            return {
                charts : {
                  lineChartVisible: false,
                  lineMultiplesVisible: false,
                  pragmaticsBubbleVisible: false,
                  methodBubbleVisible: false,
                  aestheticsBubbleVisible: false,
                  blendedBubbleVisible: false,
                  barChartVisible: false,
                  barMultiplesVisible : false,
                  timelineChartVisible : false,
                  pieChartVisible : false
                },
                showAppModal : false,
                showModalButton: false,
                showAppText: true,
                customData : {
                  title: '',
                  closeButtonText: 'Close'
                },
                items: data,
                itemsByYear : dataByYear
            }
        },
        methods : {

            onHomeClick: function() {
              this.showModalButton = false;
              this.showAppText = true;
              this.resetCharts();
              this.$router.push('/').catch(error => {});
            },
            onChartClick(chart) {
              this.showModalButton = true;

              // hide all the charts
              this.resetCharts();
              // hide the text box
              this.showAppText = false;

              // show selected chart
              Object.keys(this.charts).forEach(key => {
                if(key === chart){
                  if(this.charts[key] === false){
                    this.charts[key] = true;
                  }
                }
              });
            },
            onScatterClick()  {
              this.$router.push('/scatterchart').catch(error => {});
            },
            onTimelineClick() {
              this.$router.push('/timelinechart').catch(error => {});
            },
            resetCharts() {
              // reset all charts to false
              Object.keys(this.charts).forEach(key => {
                this.charts[key] = false;
              });
            }
        },
        created()  {
          // console.log(this.items);
        }
    }

</script>

<style scoped>

  ol {
      padding-left: 15px;
  }

  #logo {
    height: 60px;
  }


</style>
